"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderItemsResponseToJSON = exports.GetOrderItemsResponseFromJSONTyped = exports.GetOrderItemsResponseFromJSON = void 0;
var _1 = require("./");
function GetOrderItemsResponseFromJSON(json) {
    return GetOrderItemsResponseFromJSONTyped(json, false);
}
exports.GetOrderItemsResponseFromJSON = GetOrderItemsResponseFromJSON;
function GetOrderItemsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderItems': (json['orderItems'].map(_1.PreviousMenuOrderItemFromJSON)),
    };
}
exports.GetOrderItemsResponseFromJSONTyped = GetOrderItemsResponseFromJSONTyped;
function GetOrderItemsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderItems': (value.orderItems.map(_1.PreviousMenuOrderItemToJSON)),
    };
}
exports.GetOrderItemsResponseToJSON = GetOrderItemsResponseToJSON;
